import styled from 'styled-components'

export const Main = styled.div`
	width: 100%;
	padding: 16px;
`